/**
 * getAppMode
 * @author marvinqi
 * @createTime 2017/9/20
 */

import getUA from './getUA'
export default function () {
  return (/env\/([^ ]+)/.exec(getUA()) || ['', 'release'])[1] //app环境DEBUG、TEST、PRE、RELEASE
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/getAppMode.js